<template>
  <div id="app">  
    <Head />  
    <router-view/> 
  </div> 
</template>

<script> 
import Head from './components/header.vue'
import wx from 'weixin-js-sdk'
export default {
  name: 'App',
  date(){
    return {
      userName:''
    }
  },
  components: { 
    Head
  },
  methods:{ 
    setWx(data){ 
      wx.config({
        debug: false,
        appId: data.appId, 
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ["updateAppMessageShareData","updateTimelineShareData"]
      }); 
      let title=this.userName+"邀请你注册图表神器花火，免费领"+(new Date().getMonth()>3?5:30)+"天会员！";
      let desc='海量动态图表、数据短视频随心做。';
      let link=window.location.origin+'/activity?code='+this.$route.query.code;
      let imgUrl="https://img.hanabi.cn/_6648051269040603138.png"; 
      wx.ready(function () {   //需在用户可能点击分享按钮前就先调用 
        wx.updateAppMessageShareData({ //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          title: title, // 分享标题 
          desc:desc,
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // 分享图标
          success: function () { 
            // 设置成功
          }
        })
        wx.updateTimelineShareData({ //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            title: title, // 分享标题 
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 设置成功 
            }
        })
      }); 
    },
    getWxData(){
      let url=localStorage.apiUrl+'/api/wx/js/config'
      this.$http.post(url,{url:window.location.href}).then(res=>{
        if(res.data.code==200){
          this.setWx(res.data)
        }
      })
    },
    getTerminal() {
      var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet =
          /(?:iPad|PlayBook)/.test(ua) ||
          (isAndroid && !/(?:Mobile)/.test(ua)) ||
          (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
      };
    }, 
  },
  created(){
    let url=localStorage.apiUrl+'/api/invite/code/info?code='+this.$route.query.code; 
    let type=this.getTerminal();  
    if(this.$route.query.code){
      !type.isPc&&this.$http.get(url).then(res=>{
        if(res.data.code==200){
            this.userName=res.data.data.name; 
            this.getWxData();
        }
      })
    } 
  },
  mounted(){  
  },
}
</script>

<style> 
@import "./assets/css/reset.css"; 
.width1280{ 
  min-width: 1280px;
  margin: 0 auto;
} 
@media screen and (max-width:600px){
  #app{
    overflow: hidden;
  }
  .width1280{
    min-width: 100%;
  }
  .copyRight{
    font-size: 10px; 
  }
} 
</style>
